import PromotionIcon2x from "@3gaam/shared/assets/images/fs-sarsari-1403-2x.png";
import PromotionIcon from "@3gaam/shared/assets/images/fs-sarsari-1403.png";

import { useBreakpoints } from "@3gaam/shared/hooks/useBreakpoints";
import { Promotion } from "./Promotion";

const Active = true;

export const PromotionProvider = ({ lowMdOnly }: { lowMdOnly?: boolean }) => {
  let breakpointState = useBreakpoints("lg");
  let lowerMd = breakpointState === "lower";

  if (lowMdOnly && !lowerMd) return null;
  if (!Active) return null;
  return (
    <Promotion
      backgroundColor="#f7941d"
      startDateInUtc="2026-08-10T15:30:00.000Z"
      targetDateInUtc="2026-10-16T20:30:00.000Z"
      hasPreload={false}
      hideCountDown={false}
      icon={<img src={PromotionIcon} srcSet={PromotionIcon2x} />}
      preTitle={undefined}
      title="نرم افزار تخمین قبولی دانشگاه آزاد"
      preDescription={undefined}
      description="چک کن که شانس طلایی قبولیت نسوزه"
      preLink={undefined}
      link="https://3gaam.ir/e3T"
      />
  );
};
